module.exports = "/assets/pigeon.png";